import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";

import gmailIcon from "../../images/gmail.svg";

export default function Contact() {
  return (
    <div style={{ paddingBottom: "300px" }} className="container">
      <h1>Contact Me</h1>
      <div className="row">
        <div className="col">
          <ul className="list-unstyled m-5">
            <li className="my-4">
              <a
                href="mailto:youssef.ojeil@gmail.com"
                className="link-light text-decoration-none "
              >
                <img src={gmailIcon} alt="gmail" className="mb-1 mx-2" />
                <span className="ml-2">youssef.ojeil@gmail.com</span>
              </a>
            </li>
            <li className="my-4">
              <a
                href="https://github.com/youssefojeil"
                target="_blank"
                className="link-light text-decoration-none"
                rel="noreferrer"
              >
                <FontAwesomeIcon
                  className="social-media-icons mx-2"
                  icon={faGithub}
                />{" "}
                Github Profile
              </a>
            </li>
            <li className="my-4">
              <a
                href="https://www.linkedin.com/in/youssefojeil/"
                target="_blank"
                className="link-light text-decoration-none"
                rel="noreferrer"
              >
                <FontAwesomeIcon
                  className="social-media-icons mx-2"
                  icon={faLinkedin}
                />{" "}
                LinkedIn Profile
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
